import React, { useEffect, useState } from 'react';
import { List, Moon, Sun, Bell, BellSlash } from '@phosphor-icons/react';
import { formatLongDate, todayISO } from '../helpers';
import { pushSupported, getPushState, enablePush, disablePush } from '../push';
import { showToast } from './Toast';

export default function Topbar({ pageLabel, onMenuOpen }) {
  const [dark, setDark] = useState(() => {
    const saved = localStorage.getItem('vf-theme');
    return saved === 'dark';
  });
  const [pushState, setPushState] = useState('off'); // off | on | denied | unsupported
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (dark) document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
    localStorage.setItem('vf-theme', dark ? 'dark' : 'light');
  }, [dark]);

  useEffect(() => {
    if (pushSupported()) getPushState().then(setPushState).catch(() => {});
  }, []);

  async function togglePush() {
    if (busy) return;
    setBusy(true);
    try {
      if (pushState === 'on') {
        await disablePush();
        setPushState('off');
        showToast('Notifications turned off on this device');
      } else if (pushState === 'denied') {
        showToast('Notifications are blocked — enable them in your browser settings');
      } else {
        await enablePush();
        setPushState('on');
        showToast('Notifications enabled on this device! 🔔');
      }
    } catch (e) {
      showToast('Failed: ' + e.message);
    } finally {
      setBusy(false);
    }
  }

  const bellTitle = pushState === 'on'
    ? 'Notifications ON — click to turn off'
    : pushState === 'denied'
      ? 'Notifications blocked in browser settings'
      : 'Enable notifications on this device';

  return (
    <div className="topbar">
      <div className="topbar-left">
        {/* Hamburger — only visible on mobile (CSS) */}
        <button
          className="btn-menu-mobile"
          onClick={onMenuOpen}
          aria-label="Open menu"
        ><List size={20} weight="bold" /></button>
        <div className="page-breadcrumb">Melville Motors / <span>{pageLabel}</span></div>
        <div className="topbar-pills">
          <span className="tpill k">KIA</span>
          <span className="tpill s">SUZUKI</span>
          <span className="tpill g">GWM</span>
        </div>
      </div>
      <div className="topbar-right">
        <div className="topbar-date">{formatLongDate(todayISO())}</div>
        {pushSupported() && (
          <button
            className="btn-theme-top"
            onClick={togglePush}
            disabled={busy}
            title={bellTitle}
            style={pushState === 'on' ? { borderColor: 'var(--accent)', background: 'var(--accent-bg)', color: 'var(--accent)' } : null}
          >
            {pushState === 'on' ? <Bell size={16} weight="fill" /> : <BellSlash size={16} weight="duotone" />}
          </button>
        )}
        <button
          className="btn-theme-top"
          onClick={() => setDark((d) => !d)}
          title="Toggle dark/light mode"
        >
          {dark ? <Sun size={16} weight="fill" /> : <Moon size={16} weight="duotone" />}
        </button>
      </div>
    </div>
  );
}
